module.exports = __webpack_public_path__ + "static/media/animal_04_big.155ef611.png";